import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';
import type { CreateFlagArgs, DismissFn } from '@atlaskit/flag/flag-provider';

import { ApiUtil } from '../../apis/live/ApiUtil';
import { type Environment } from '../../models';
import { type BackendSettings } from '../../models/BackendSettings';
import { type ErrorUtils } from '../ErrorUtils';
import { setNoticeLocale } from '../show-notice';
import { LiveErrorUtils } from './LiveErrorUtils';

export interface CreatedUtils {
	apiUtil: ApiUtil;
	errorUtils: ErrorUtils;
}

export function createErrorUtils(
	errorUtilsModuleName: string,
	environment: Environment,
	createAnalyticsEvent: CreateUIAnalyticsEvent,
	showFlag: (args: CreateFlagArgs) => DismissFn = () => () => {},
): ErrorUtils {
	return new LiveErrorUtils(errorUtilsModuleName, showFlag, createAnalyticsEvent, environment);
}

export function createUtils(
	settings: BackendSettings<any>,
	errorUtilsModuleName: string,
	showFlag: (args: CreateFlagArgs) => DismissFn,
	createAnalyticsEvent: CreateUIAnalyticsEvent,
	locale: string,
): CreatedUtils {
	const errorUtils = new LiveErrorUtils(
		errorUtilsModuleName,
		showFlag,
		createAnalyticsEvent,
		settings.environment,
	);

	setNoticeLocale(locale);
	const apiUtil = new ApiUtil(
		settings.urls.jira,
		settings.urls.api,
		errorUtils,
		createAnalyticsEvent,
	);

	return {
		apiUtil,
		errorUtils,
	};
}

// Same as createUtils above but we separate out the parts of the settings object that we want as separate parameters
export function createUtils2(
	jiraUrl: string,
	apiUrl: string,
	environment: Environment,
	errorUtilsModuleName: string,
	showFlag: (args: CreateFlagArgs) => DismissFn,
	createAnalyticsEvent: CreateUIAnalyticsEvent,
	locale: string,
): CreatedUtils {
	const errorUtils = new LiveErrorUtils(
		errorUtilsModuleName,
		showFlag,
		createAnalyticsEvent,
		environment,
	);

	setNoticeLocale(locale);
	const apiUtil = new ApiUtil(jiraUrl, apiUrl, errorUtils, createAnalyticsEvent);

	return {
		apiUtil,
		errorUtils,
	};
}
